import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=68a24366&scoped=true"
import script from "./LinkItem.vue?vue&type=script&lang=js"
export * from "./LinkItem.vue?vue&type=script&lang=js"
import style0 from "./LinkItem.vue?vue&type=style&index=0&id=68a24366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a24366",
  null
  
)

export default component.exports